<template>
  <el-dialog
      :visible.sync="visible"
      title="账单明细"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-row :gutter="20">
      <el-col :span="6">
        <m-label label="申请编号">{{ receiptInfo.batchCode }}</m-label>
      </el-col>
      <el-col :span="6">
        <m-label label="发票号">
          <span v-if="$c.str2bool(receiptInfo.code)">{{ receiptInfo.code }}</span>
          <div style="display: flex" v-if="showCodeInput">
            <el-input v-model="newCode" size="mini" placeholder="请输入发票号" style="width: 200px;"></el-input>
          </div>
        </m-label>
      </el-col>
      <el-col :span="6">
        <m-label label="开票日期">
          <span v-if="$c.str2bool(receiptInfo.operateDate)&&!showCodeInput">{{ receiptInfo.operateDate }}</span>
          <el-date-picker
              v-if="showCodeInput"
              v-model="receiptInfo.operateDate"
              type="date"
              value-format="yyyy-MM-dd"
              size="mini"
              style="width: 200px;"
              placeholder="选择日期">
          </el-date-picker>
        </m-label>
      </el-col>
      <el-col :span="6">
        <m-label label="审核状态">
          <el-tag type="primary">{{ $const.auditStatus[receiptInfo.auditStatus] }}</el-tag>
        </m-label>
      </el-col>
      <el-col :span="6">
        <m-label label="申请人">{{ receiptInfo.creatorName }}</m-label>
      </el-col>
      <el-col :span="6">
        <m-label label="申请时间">{{ receiptInfo.createDate }}</m-label>
      </el-col>
      <el-col :span="6">
        <m-label label="审核人">{{ receiptInfo.auditManName }}</m-label>
      </el-col>
      <el-col :span="6">
        <m-label label="审核时间">{{ receiptInfo.auditDate }}</m-label>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" v-if="$hasPermission('erp:receipt:code')&&showCodeInput" size="mini" icon="el-icon-check" style="margin-left: 10px" @click="submitCode()">
          保存开票信息
        </el-button>
      </el-col>
    </el-row>
    <SweetTable ref="table" api-version="v2" url="/erp/receipt/detail/page" :data="dataList" :is-page="false"
                :before-table-binding="beforeTableBinding"
                :summaries-column="['amount','count']" :height="520">
      <el-table-column
          prop="orderCode"
          label="外销合同编号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="110"
      ></el-table-column>
      <el-table-column
          prop="orderReceiptAccount"
          label="开票户头"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="110"
      ></el-table-column>
      <el-table-column
          prop="sendBatchCode"
          label="发货批次号"
          header-align="center"
          align="center"
          width="110"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="sellerName"
          label="发货方"
          header-align="center"
          align="center"
          min-width="140"
          :formatter="$c.companyNameFormatter"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="receiverName"
          label="收货方"
          header-align="center"
          align="center"
          :formatter="$c.companyNameFormatter"
          :show-overflow-tooltip="true" v-if="$hasPermission('erp:receipt:audit')"
          min-width="140"
      ></el-table-column>
      <el-table-column
          label="货物信息"
          header-align="center"
          align="center"
          min-width="180"
      >
        <template #default="{row}">
          <ProductRowCard :product="row.product"></ProductRowCard>
        </template>
      </el-table-column>
      <el-table-column
          prop="planPrice"
          label="计划单价"
          header-align="center"
          align="center"
          width="90"
      >
      </el-table-column>
      <el-table-column
          prop="price"
          label="发货单价"
          header-align="center"
          align="center"
          width="90"
      >
      </el-table-column>
      <el-table-column
          prop="count"
          label="开票数"
          header-align="center"
          align="center"
          width="90"
      >
      </el-table-column>
<!--      <el-table-column-->
<!--          label="收货数"-->
<!--          header-align="center"-->
<!--          align="center"-->
<!--          prop="receiveCount"-->
<!--          width="90"-->
<!--      >-->
<!--      </el-table-column>-->
      <el-table-column
          label="金额"
          header-align="center"
          align="center"
          prop="amount"
          width="90"
      >
      </el-table-column>

      <el-table-column
          label="发货时间"
          header-align="center"
          align="center"
          prop="sendOptTime"
          width="100"
      >
      </el-table-column>
      <el-table-column
          label="收货时间"
          header-align="center"
          align="center"
          prop="receiveOptTime"
          width="100"
      >
      </el-table-column>
      <el-table-column
          label="审核状态"
          header-align="center"
          align="center"
          prop="receiveOptTime"
          width="80"
      >
        <template #default="{row}">
          {{ $const.auditStatus[row.auditStatus] }}
        </template>
      </el-table-column>
      <el-table-column
          label="审核人"
          header-align="center"
          align="center"
          prop="auditManName"
          width="80"
      >
      </el-table-column>
      <el-table-column
          label="审核时间"
          header-align="center"
          align="center"
          prop="auditTime"
          width="160"
      >
      </el-table-column>
    </SweetTable>
  </el-dialog>
</template>

<script>
/**
 * 账单明细弹窗
 */
import { moneyValidator, isPositiveNumber } from '@/utils/validate'
import debounce from 'lodash/debounce'
import ProductRowCard from '@/components/ProductRowCard'
import BigNumber from 'bignumber.js'

export default {
  name: 'detail-dialog',
  components: {
    ProductRowCard,
  },
  data () {
    return {
      id: '',
      visible: false,
      dataList: [],
      receiptInfo: {},
      newCode: ''//要设置的新发票号
    }
  },
  computed: {
    showCodeInput () {   // 是否显示输入发票号的输入框
      if (!this.receiptInfo) {
        return false
      }
      if (this.$c.str2bool(this.receiptInfo.code)) {
        return false
      }
      if (this.receiptInfo.auditStatus !== 20) {
        return false
      }
      if(!this.$hasPermission('erp:receipt:code')){
        return false
      }
      return true
    }
  },
  methods: {
    init (receiptId) {
      this.newCode = ''
      this.id = receiptId
      this.getReceiptInfo()
      this.getReceiptDetail()
      this.visible = true
    },
    getReceiptDetail () {
      this.$api2.get(`/erp/receipt/detail/page`, { params: { pid: this.id, page: 1, limit: 10000000 } }).then(res => {
        res.list.forEach(item => {
          item.totalAmount = new BigNumber(item.price).multipliedBy(item.receiveCount).toFixed(2)
        })
        this.dataList = res.list
      })
    },
    getReceiptInfo () {
      this.$api2.get(`/erp/receipt/${this.id}`).then(res => {
        this.receiptInfo = res
      })
    },
    submitCode () {
      if (!this.newCode) {
        this.$message.error('请输入发票号')
        return
      }
      this.$confirm(`确定要上传发票号【${this.newCode}】吗？`, '提示').then(() => {
        this.$api2.post('/erp/receipt/code/save', { id: this.id, code: this.newCode,operateDate:this.receiptInfo.operateDate }).then(res => {
          this.getReceiptInfo()
          this.getReceiptDetail()
          this.$message.success('发票号已保存')
        })
      })
    },
    beforeTableBinding (dataList) {

    }
  }
}
</script>
